import EffectorBase, { DurationDeterminingEffector } from "./EffectorBase";
import { CustomEventTypes } from '../../../globals';
import AudioSource from "../../AudioSource";
import Utils from '../../Utilities';
import { TimelineFragment } from "../TimelineFragment";

export default class EffectorAudioPlayback extends EffectorBase<EffectorAudioPlayback> implements DurationDeterminingEffector 
{
	isPlaying: boolean;

	constructor(fragment : TimelineFragment)
	{
		super(fragment);
		this.isPlaying = false;
	}

	save = () =>
	{

	}

	load = (savedData: any) =>
	{

	}

	copyValues = (sourceEffector : EffectorAudioPlayback) =>
	{

	}

	getInitialDuration = () : number => 
	{
		const targetObjects = this.targetObjects();
		if(targetObjects.length > 0)
		{
			const audioSource = targetObjects[0] as AudioSource;
			if (audioSource?.audio?.buffer?.duration)
			{
				return audioSource.audio.buffer.duration;
			}
		}

		return 0;
	}

	playAudio = () =>
	{
		if (!this.isPlaying)
		{
			this.forEachTargetObject(function(targetObject)
			{
				if (targetObject.userData.audio) (targetObject as AudioSource).playAudio();
			});
			this.isPlaying = true;
		}
	}

	stopAudio = () =>
	{
		if (this.isPlaying)
		{
			this.forEachTargetObject(function(targetObject)
			{
				if (targetObject instanceof AudioSource) (targetObject as AudioSource).stopAudio();
			});
			this.isPlaying = false;
		}
	}

	resetState = () =>
	{

	}

	update = (fragmentTime: number) =>
	{
		if (!Utils.IsSimulationRunning()) return;

		if (this.fragment.previousTime > fragmentTime) this.stopAudio();

		if (fragmentTime > 0 && fragmentTime < 1) 
		{
			this.playAudio();
		}
		else 
		{
			this.stopAudio();
		}
	}

	onAdded = () =>
	{
		document.addEventListener(CustomEventTypes.simulationStopped, this.stopAudio);
		document.addEventListener(CustomEventTypes.onUnloadScene, this.stopAudio);
	}

	onDelete = () =>
	{
		this.stopAudio();
		super.onDelete();
		document.removeEventListener(CustomEventTypes.simulationStopped, this.stopAudio);
		document.removeEventListener(CustomEventTypes.onUnloadScene, this.stopAudio);
		this.isPlaying = false;
	}

	getEditorProperties = () =>
	{
		return [...this.getCommonPropertyDrawers()];
	}
}
